<template lang="">
    <v-container class="mt-7"
    style="background-color: #F9F9FC;"> 
          <h2 >Sales Trends</h2>
          <TableuVue :url="url"/>  
    </v-container>
</template>
<script>

import TableuVue from '@/components/Tableu.vue'

export default {
    components:{  
        TableuVue
      
    },
    data(){
        return{
          url:null
        }
    }, 
    methods:{
        getLinkTablue(){
            let link= this.$session.getAll().user.tableau_list
            link.forEach(x =>{
               if(x.purpose =="salestrend"){
                    this.url = x.link             
               }
            } )
        }
    },
     created(){
          if (localStorage.getItem('reloaded')) {
            localStorage.removeItem('reloaded');
        } else {
            localStorage.setItem('reloaded', '1');
            location.reload();
        }
        this.getLinkTablue()
     },
    mounted () {
  },
}
</script>
<style lang="">
    
</style>